const DustbinUsed = (props) => {
  return (
    <div className="chart_2">
      <h1>
        Number of times used <p>(V1)</p>
      </h1>
      <p>{props.numOftimeUsed}</p>
    </div>
  );
};
export default DustbinUsed;
